import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';

import '@stubhub/react-font-icons';

import FooterBottom from './footer-bottom';
import FooterTop from './footer-top';

import '../styles/footer.scss';

class FooterNew extends Component {
  constructor(props, ctx) {
    super(props, ctx);
  }

  render() {
    const {globalRegistry} = this.context;
    const {isHomepage, showSaudiArabiaVAT} = this.props;
    const storeId = globalRegistry.getStoreId();

    return (
      <footer className="global-footer-container">
        <div className="footer-wrapper">
          <div className="footer-main">
            <FooterTop isHomepage={isHomepage} />
            <FooterBottom storeId={storeId} showSaudiArabiaVAT={showSaudiArabiaVAT} />
          </div>
        </div>
      </footer>
    );
  }
}

FooterNew.contextTypes = {
  globalRegistry: PropTypes.object,
};

FooterNew.propTypes = {
  /** Whether we are in the home page */
  isHomepage: PropTypes.bool,

  /** Whether we should show the Saudi Arabia VAT logo */
  showSaudiArabiaVAT: PropTypes.bool,
};

export default injectIntl(FooterNew);
